import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "../config";
import type { Vocation } from "../index";

interface GameOverData {
  winnerName: string;
  winnerVocation: Vocation;
  winnerHp: number;
  winnerMaxHp: number;
}

/**
 * Match-over screen. Shows winner + final HP, with keyboard shortcuts to
 * rematch (R) or return to the homepage (M / Esc).
 */
export class GameOverScene extends Phaser.Scene {
  private payload!: GameOverData;

  constructor() {
    super("GameOverScene");
  }

  init(data: GameOverData): void {
    this.payload = data;
  }

  create(): void {
    const cx = GAME_WIDTH / 2;
    const cy = GAME_HEIGHT / 2;

    this.add.rectangle(cx, cy, GAME_WIDTH, GAME_HEIGHT, 0x0b1020, 0.92);

    this.add
      .text(cx, cy - 110, "VICTORY", {
        fontFamily: "monospace",
        fontSize: "52px",
        color: "#fde047",
      })
      .setOrigin(0.5);

    this.add
      .text(cx, cy - 50, this.payload.winnerName, {
        fontFamily: "monospace",
        fontSize: "36px",
        color: this.payload.winnerVocation === "warrior" ? "#f97316" : "#22d3ee",
      })
      .setOrigin(0.5);

    this.add
      .text(
        cx,
        cy - 10,
        `the ${this.payload.winnerVocation} survived with ${this.payload.winnerHp} / ${this.payload.winnerMaxHp} HP`,
        {
          fontFamily: "monospace",
          fontSize: "18px",
          color: "#cbd5e1",
        },
      )
      .setOrigin(0.5);

    this.add
      .text(cx, cy + 80, "[R] Rematch", {
        fontFamily: "monospace",
        fontSize: "22px",
        color: "#f97316",
      })
      .setOrigin(0.5);
    this.add
      .text(cx, cy + 115, "[M] Main menu", {
        fontFamily: "monospace",
        fontSize: "22px",
        color: "#94a3b8",
      })
      .setOrigin(0.5);

    this.input.keyboard?.on("keydown-R", () => {
      this.scene.start("ArenaScene");
    });
    this.input.keyboard?.on("keydown-M", () => {
      window.location.reload();
    });
    this.input.keyboard?.on("keydown-ESC", () => {
      window.location.reload();
    });
  }
}
